import { render, staticRenderFns } from "./Referees.vue?vue&type=template&id=65a74128&scoped=true&"
import script from "./Referees.vue?vue&type=script&lang=js&"
export * from "./Referees.vue?vue&type=script&lang=js&"
import style0 from "./Referees.vue?vue&type=style&index=0&id=65a74128&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65a74128",
  null
  
)

export default component.exports